import { useMutation} from "@tanstack/react-query";
import { API_BASE_PATH, API_BASE_RELATIVE_PATH } from "../Config/Config";
import axios from "axios";

const deleteTC = async ({ id }) => {
  const userDetails = localStorage.getItem("userDetail");
  if (!userDetails) throw new Error("No user details found in localStorage");
  const user = JSON.parse(userDetails);

  const response = await axios
    .get(
      `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=deleteTC&companyid=${user.companyid}&tcid=${id}`,
    )
;

  return response;
};

const useDeleteTCQuery = (options = {}) => {


  return useMutation({
    mutationFn: deleteTC,

    ...options,
  });
};

export default useDeleteTCQuery;
